import { Injectable } from '@angular/core';
import { IValidation, IValidator } from '../interface';

@Injectable({ providedIn: 'root' })
export class Validator implements IValidator {

  get validations(): Array<IValidation> {
    if (!window["validations"]) {
      window["validations"] = [];
    }
    return window["validations"] as Array<IValidation>;
  }

  public Add(validation: IValidation) {
    window["validations"].push(validation);
  }

  public Clear() {
    window["validations"] = [];
  }

  public get Count(): number {
    return window["validations"].length;
  }

  public Validate(fieldName: string): string {
    let error = this.validations.find((item) => item.FieldName == fieldName);
    if (error) {
      return error.Message;
    }
    return '';
  }
  
    
}

